import Vue from 'vue'
import VueRouter from 'vue-router'

// отложенная загрузка компонентов методом import()
// import About from '../views/About'
// import Home from '../views/Home'
// import Login from '../views/auth/Login'
// import Lost from '../views/Lost'
// import RunPlan from '../views/runs/RunPlan'
// import BarcodeRemainsList from '../views/barcodes/BarcodeRemainsList'

// import PasswordReset from '../views/PasswordReset';

import store from '../store'

const requireAuthenticated = (to, from, next) => {
	/* В первый раз сюда попадаем даже не из нашего кода,
	 * а потому что router перенаправляет { path:'/', redirect: '/home' },
	 * а для пути '/home' задан { beforeEnter: requireAuthenticated}
	 */
	return store.dispatch('auth/initialize') // здесь вызываем action (действие) testLogin модуля auth store.auth.initialize()
		.then(() => {
			if (!store.getters['auth/isAuthenticated']) {
				next({path: '/login?from=' + to.path});
			} else {
				next();
			}
		});
};

const requireAuthenticated_and_id_valid = (to, from, next) => {
	return store.dispatch('auth/initialize') // здесь вызываем action (действие) testLogin модуля auth store.auth.initialize()
		.then(() => {
			if (!store.getters['auth/isAuthenticated']) {
				next({path: '/login?from=' + to.path})
			} else {
				store.dispatch('runs/fetchData')
					.then(() => {
						next()
					})
					.catch(() => {
						next('/')
					})
			}
		});
}

const requireAuthenticated_and_getRuns = (to, from, next) => {
	return store.dispatch('auth/initialize') // здесь вызываем action (действие) testLogin модуля auth store.auth.initialize()
		.then(() => {
			if (!store.getters['auth/isAuthenticated']) {
				next({path: '/login?from=' + to.path})
			} else {
				store.dispatch('runs/getRuns', {
					page: 1,
					per_page: 12,
					planning: false
				})
					.then(() => {
						next()
					})
				// .catch(() => {
				//   next('/')
				// })
			}
		});
}

const requireSuperuser_and_get_references_from_DB = (to, from, next) => {
	return store.dispatch('auth/initialize') // здесь вызываем action (действие) testLogin модуля auth store.auth.initialize()
		.then(() => {
			if (!store.getters['auth/isAuthenticated']) {
				next({path: '/login?from=' + to.path})
			}
			else if (!store.getters['auth/is_superuser']) {
				next('/');
			} else {
				store.dispatch('runs/fetchData', {run_id: null})
					.then(() => {
						next()
					})
					.catch(() => {
						next('/')
					})
			}
		});
}

const requireUnauthenticated = (to, from, next) => {
	return store.dispatch('auth/initialize')
		.then(() => {
			if (store.getters['auth/isAuthenticated']) {
				next('/home');
			} else {
				next();
			}
		});
};

const redirectLogout = (to, from, next) => {
	return store.dispatch('auth/logout')
		.then(() => next('/login'));
};


Vue.use(VueRouter);

const router = new VueRouter({

	scrollBehavior: function (to, from, savedPosition) {
		return savedPosition || {x: 0, y: 0}
	},

	routes: [
		{
			path: '/',
			redirect: '/home',
		},
		{
			path: '/about',
			component: () => import('../views/About'), // Anout
			// на странице описания можно указать контакты для получения доступа, например
			beforeEnter: requireAuthenticated,
		},
		{
			path: '/home',
			component: () => import('../views/Home'), // Home
			beforeEnter: requireAuthenticated,
		},
		{
			path: '/run_plan/:id',
			component: () => import('../views/runs/RunPlan'), // RunPlan
			beforeEnter: requireAuthenticated_and_id_valid,
		},
		{
			path: '/plan_run',
			component: () => import('../views/runs/RunPlan'), // RunPlan
			beforeEnter: requireSuperuser_and_get_references_from_DB
		},
		{
			path: '/barcode_remains',
			component: () => import('../views/barcodes/BarcodeRemainsList'), // BarcodeRemainsList,
			beforeEnter: requireAuthenticated
		},
		{
			path: '/issues',
			beforeEnter: function (to, from, next) {
				// window.location.href = process.env.VUE_APP_ISSUES_URL
				window.open(process.env.VUE_APP_ISSUES_URL, '_blank').focus()
			},
		},
		{
			path: '/admin',
			beforeEnter: function (to, from, next) {
				window.location.href = process.env.VUE_APP_ADMIN_URL
			},
		},

		// {
		//   path: '/password_reset',
		//   component: PasswordReset,
		// },
		// {
		//   path: '/password_reset/:uid/:token',
		//   component: PasswordResetConfirm,
		// },
		// {
		//   path: '/register',
		//   component: Register,
		// },
		// {
		//   path: '/register/:key',
		//   component: VerifyEmail,
		// },
		{
			path: '/login',
			component: () => import ('../views/auth/Login'), //Login,
			beforeEnter:
			requireUnauthenticated,
		},
		{
			path: '/logout',
			beforeEnter:
			redirectLogout,
		},
		{
			path: '*',
			component: () => import ('../views/Lost'), // Lost
		},
	],

})


export default router
